import Card, { CardActionButton, CardDivider } from '@digital-hig/card';
import { t, Trans } from '@lingui/macro';
import { PropTypes } from 'prop-types';
import React from 'react';
import parse from 'html-react-parser';
import { CardActionArea, CardActions, CardContent, Grid } from '@mui/material';

const CHAR_LIMIT = 400;

/**
 * The body text can contain a lot of different html. This is a simple approach to remove any
 * html elements found which render as [Object,object].
 *
 * @param {string} body
 * @returns string of body text for display
 */
export const getArticleBody = (body) => {
  let result = '';
  if (body) {
    let replacedBody = body;
    replacedBody = replacedBody.replace(/\t/g, '');
    replacedBody = replacedBody.replace(/\n/g, '');
    replacedBody = replacedBody.replace(/<(|\/.*)[^>]*>/g, '');
    const snippet = replacedBody ? replacedBody.slice(0, CHAR_LIMIT) : '';
    const bodyData = parse(snippet);
    // not 100% accurate since body length with html tags, etc. can be longer
    result = body.length > CHAR_LIMIT ? `${bodyData}...` : bodyData;
  }
  return result;
};

const RecommendedContentComponent = ({ recommendedContent, bannerBoxData }) => (
  <div>
    {recommendedContent.length ? (
      <div>
        <h2 className="section-title dhig-typography-headline-medium dhig-mt-0 dhig-mb-8">
          {t`View proven solutions for specific ${bannerBoxData?.productName} issues`}
        </h2>
        <Grid container style={{ paddingLeft: 0, paddingRight: 0 }}>
          {recommendedContent?.map((article) => {
            const url =
              article.url || article.contentUrl
                ? article.url || article.contentUrl
                : `/support/technical/article/${article.caasKey}`;
            return (
              <Grid
                className="jest-item"
                item
                md={4}
                sm={12}
                sx={{ pt: 4 }}
                key={article.title}
              >
                <CardActionArea
                  aria-label={article.title}
                  href={url}
                  key={article.caasKey}
                  style={{
                    height: '100%'
                  }}
                  className="no-hover dhig-p-0"
                  data-wat-loc="recommended content"
                  data-wat-val={article.title.toLowerCase()}
                >
                  <Card
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      height: '100%',
                      justifyContent: 'space-between'
                    }}
                  >
                    <CardContent>
                      <h3
                        className="dhig-typography-headline-small recommended-content-title dhig-mt-0 dhig-mb-3"
                        style={{
                          textOverflow: 'ellipsis',
                          overflow: 'hidden'
                        }}
                      >
                        {article.title}
                      </h3>
                      <p
                        className="dhig-typography-body-copy-medium recommended-content-snippet dhig-mt-0 dhig-mb-0"
                        style={{
                          textOverflow: 'ellipsis',
                          overflow: 'hidden'
                        }}
                      >
                        {getArticleBody(article.shortDescription)}
                      </p>
                    </CardContent>
                    <div>
                      <CardDivider />
                      <CardActions style={{ display: 'block' }}>
                        <CardActionButton
                          style={{
                            padding: '0px',
                            textTransform: 'none'
                          }}
                          className="recommended-content-action"
                        >
                          <Trans>See article</Trans>
                        </CardActionButton>
                      </CardActions>
                    </div>
                  </Card>
                </CardActionArea>
              </Grid>
            );
          })}
        </Grid>
      </div>
    ) : null}
  </div>
);

export default RecommendedContentComponent;

RecommendedContentComponent.propTypes = {
  /**
   * data for the current product
   */
  bannerBoxData: PropTypes.shape({
    productName: PropTypes.string.isRequired
  }).isRequired,
  /**
   * documentation array
   */
  recommendedContent: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      caasKey: PropTypes.string.isRequired,
      shortDescription: PropTypes.string.isRequired
    })
  ).isRequired
};
